import { lazy } from 'react';
import { Loadable } from 'components';
import { AuthLayout } from 'layouts';
import { Navigate, useRoutes } from 'react-router-dom';

const SignIn = Loadable(lazy(() => import('screens/Authentication/SignIn')));
const SignUp = Loadable(lazy(() => import('screens/Authentication/SignUp')));
const ResetPassword = Loadable(lazy(() => import('screens/Authentication/ResetPassword')));

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to="/sign-in" replace />,
    },
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        { path: 'sign-in', element: <SignIn /> },
        { path: 'sign-up', element: <SignUp /> },
        { path: 'reset-password', element: <ResetPassword /> },
      ],
    },
    { path: '*', element: <Navigate to="/sign-in" replace /> },
  ]);
}
